export const GET_PROGRAM_CERTIFICATE = "GET_PROGRAM_CERTIFICATE";
export const GET_PROGRAM_CERTIFICATE_BY_ID = "GET_PROGRAM_CERTIFICATE_BY_ID";
export const GET_STUDENT_BATCH_CERTIFICATE = "GET_STUDENT_BATCH_CERTIFICATE";
export const GET_PROGRAM_SELECTLIST_FOR_CERTIFICATE =
  "GET_PROGRAM_SELECTLIST_FOR_CERTIFICATE";
